import React from 'react';
import {cn} from '@/utils';

interface TableColumn {
  key: string;
  title: string;
  width?: string;
}

interface DataTableProps {
  columns: TableColumn[];
  data: Record<string, any>[];
  className?: string;
}

const DataTable: React.FC<DataTableProps> = ({columns, data, className}) => {
  return (
    <div
      className={cn(
        'bg-bg border border-[rgba(72,80,93,0.2)] rounded-[0.6rem] overflow-hidden',
        className,
      )}>
      {/* 表头 */}
      <div className="border-b border-[rgba(72,80,93,0.2)]">
        <div className="flex">
          {columns.map((column, index) => (
            <div
              key={column.key}
              className={cn(
                'flex-1 flex items-center justify-center py-3.5 px-1.5',
                index < columns.length - 1 &&
                  'border-r border-[rgba(72,80,93,0.2)]',
              )}>
              <span className="text-[0.6rem] text-black font-normal text-center">
                {column.title}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* 表体 */}
      <div className="divide-y divide-[rgba(72,80,93,0.2)]">
        {data.map((row, rowIndex) => (
          <div key={rowIndex} className="flex">
            {columns.map((column, colIndex) => (
              <div
                key={column.key}
                className={cn(
                  'flex-1 flex items-center justify-center py-3.5',
                  colIndex < columns.length - 1 &&
                    'border-r border-[rgba(72,80,93,0.2)]',
                )}>
                <span className="text-[0.6rem] text-t2 text-center">
                  {row[column.key]}
                </span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DataTable;
